<template>
    <Breadcrumbs main="Ui Kits" title="Dropdown" />
    <div class="container-fluid">
        <div class="row">
            <basicDropdown />
            <roundedDropdown />
            <splitDropdown />
            <dropdownSection />
            <uniqueDropdown />
            <justifyContents />
            <alignmentsDropdown />
            <helperCard />
            <dividerDropdown />
            <dropdownSizing />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { ref, defineAsyncComponent } from 'vue'
const basicDropdown = defineAsyncComponent(() => import("@/components/theme/uikits/dropdown/basicDropdown.vue"))
const roundedDropdown = defineAsyncComponent(() => import("@/components/theme/uikits/dropdown/roundedDropdown.vue"))
const splitDropdown = defineAsyncComponent(() => import("@/components/theme/uikits/dropdown/splitDropdown.vue"))
const dropdownSection = defineAsyncComponent(() => import("@/components/theme/uikits/dropdown/dropdownSection.vue"))
const uniqueDropdown = defineAsyncComponent(() => import("@/components/theme/uikits/dropdown/uniqueDropdown.vue"))
const justifyContents = defineAsyncComponent(() => import("@/components/theme/uikits/dropdown/justifyContents.vue"))
const alignmentsDropdown = defineAsyncComponent(() => import("@/components/theme/uikits/dropdown/alignmentsDropdown.vue"))
const helperCard = defineAsyncComponent(() => import("@/components/theme/uikits/dropdown/helperCard.vue"))
const dividerDropdown = defineAsyncComponent(() => import("@/components/theme/uikits/dropdown/dividerDropdown.vue"))
const dropdownSizing = defineAsyncComponent(() => import("@/components/theme/uikits/dropdown/dropdownSizing.vue"))
</script>